import { LoadState } from "../../../constants/enums";

export interface IRIBOForm1State {
  data: IRIBOForm1;
  dataLoading: LoadState;
  error: string | null;
  list: IRIBOForm1[];
  loading: LoadState;
}

export interface IRIBOForm1 {
  report_code: string | null;
  principal_broker_name: string | null;
  principal_broker_reg_no: string | null;
  certification_date: string | null;
  firm_name_address: string | null;
  firm_reg_no: string | null;
  reporting_date: string | null;
  reporting_due_date: string | null;
  cash_on_hand_bank_balances_trust: string | null;
  total_premiums_receivable: string | null;
  premiums_over_ninty_days: string | null;
  allowable_premiums_receivable: string | null;
  investments_held_in_trust: string | null;
  total_assets: string | null;
  insurance_premiums_payable: string | null;
  prepaid_premiums: string | null;
  refunds_due_to_insureds: string | null;
  retail_sales_tax_payable: string | null;
  total_liabilities: string | null;
  net_trust_position: string | null;
  cash_on_hand_bank_balances_general: string | null;
  investments_non_trust: string | null;
  direct_bill_commission_receivable: string | null;
  other_receivables: string | null;
  premiums_receivable_over_ninty_days: string | null;
  total_accounts_receivable: string | null;
  due_from_trust_account: string | null;
  other_current_assets: string | null;
  total_current_assets: string | null;
  bank_overdraft: string | null;
  demand_loans: string | null;
  notes_payable: string | null;
  current_position_long_term_debt: string | null;
  accounts_payable_non_premiums: string | null;
  other_current_liabilities: string | null;
  total_current_liabilities: string | null;
  net_current_position: string | null;
  total_equity: string | null;
  paid_up_share_capital: string | null;
  shareholder_contribution_other: string | null;
  retained_earnings_deficit: string | null;
  loans_from_shareholders: string | null;
  loans_to_shareholders: string | null;
  total_equity_deficiency: string | null;
  status: string;
}

export const initialRIBOForm1State: IRIBOForm1State = {
  list: [],
  loading: LoadState.NotLoaded,
  data: {
    report_code: null,
    principal_broker_name: null,
    principal_broker_reg_no: null,
    certification_date: null,
    firm_name_address: null,
    firm_reg_no: null,
    reporting_date: null,
    reporting_due_date: null,
    cash_on_hand_bank_balances_trust: null,
    total_premiums_receivable: null,
    premiums_over_ninty_days: null,
    allowable_premiums_receivable: null,
    investments_held_in_trust: null,
    total_assets: null,
    insurance_premiums_payable: null,
    prepaid_premiums: null,
    refunds_due_to_insureds: null,
    retail_sales_tax_payable: null,
    total_liabilities: null,
    net_trust_position: null,
    cash_on_hand_bank_balances_general: null,
    investments_non_trust: null,
    direct_bill_commission_receivable: null,
    other_receivables: null,
    premiums_receivable_over_ninty_days: null,
    total_accounts_receivable: null,
    due_from_trust_account: null,
    other_current_assets: null,
    total_current_assets: null,
    bank_overdraft: null,
    demand_loans: null,
    notes_payable: null,
    current_position_long_term_debt: null,
    accounts_payable_non_premiums: null,
    other_current_liabilities: null,
    total_current_liabilities: null,
    net_current_position: null,
    total_equity: null,
    paid_up_share_capital: null,
    shareholder_contribution_other: null,
    retained_earnings_deficit: null,
    loans_from_shareholders: null,
    loans_to_shareholders: null,
    total_equity_deficiency: null,
    status: "ACTIVE",
  },
  dataLoading: LoadState.NotLoaded,
  error: null,
};
